;(function ($, YI) {YI.commerceStorey = function () {

    // индекс планировки этажа, если вдруг она не ппервая
    // ИД:итерация
    var storeyIndex = {
        22:1,
        34:1
    };

    // передаём id этажа через параметр "id" в адресной строке
    var id = Number(locationParams('id'));
    if (!id) history.back();

    // подгружаем информацию этажа
    var storey = yc('v2/dwellings/storeys/' + id);
    if (!storey) history.back();

    var i_image_maps = storeyIndex[id] === undefined ? 0 : storeyIndex[id],
        image_maps = storey['image_maps'].length ? storey['image_maps'][i_image_maps] : null;

    // собираемся svg и формируем массив с id квартир
    var fasadMaxHeight = $(window).height() - $('#headBlock').height() - $('.footer-outer').height();
    var commercialPremises = [];
    var commerce_storey_fasad = '<svg style="max-height: '+fasadMaxHeight+'px;" class="commerce-storey__fasad" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+image_maps.width+' '+image_maps.height+'" version="1.1" width="100%" height="100%" preserveAspectRatio="xMinYMin meet">' +
        '<image xlink:href="'+image_maps.path+'" width="100%" height="100%" />';
    $.each(image_maps.flats, function (i, flat) {
        commercialPremises.push({
            id: flat.id
        });
        commerce_storey_fasad += '<path class="commerce-storey__fasad__path commerce-storey__fasad__path--'+flat.status+'" d="'+flat.polygon+'" />';
    });
    commerce_storey_fasad += '</svg>';
    $('#commerce_fasad').html(commerce_storey_fasad);

    // литер (вытаскиваем один раз из любой квартиры)
    var liter = yc('v2/dwellings/flats/' + commercialPremises[0].id).house_name;
    $('#commerce_liter').text(liter);

    // работа с фасадом (наведение и клик)
    var $paths = $('.commerce-storey__fasad__path'),
        $area = $('#commerce_area'),
        $desc = $('#commerce_desc'),
        $parent_desc = $desc.parent();
    $paths.hover(function () {
        // выводим инофрмацию, если она не подгружена, то подгружаем
        var $this = $(this);
        $paths.removeClass('commerce-storey__fasad__path--hover');
        $this.addClass('commerce-storey__fasad__path--hover');
        var premise_info = commercialPremises[$this.index()];
        if (typeof premise_info.area === 'undefined' || typeof premise_info.comment === 'undefined') {
            // подгружаем инофрмацию о квартире
            var flat = yc('v2/dwellings/flats/' + premise_info.id);
            premise_info.area = flat.total_area;
            premise_info.comment = flat.comments;
        }
        $area.text(premise_info.area);
        if (premise_info.comment) {
            $desc.html(premise_info.comment);
            $parent_desc.show();
        } else {
            $parent_desc.hide();
        }
    }).eq(0).trigger('mouseover');
    $paths.filter(':not(.commerce-storey__fasad__path--sold)').click(function () {
        // переход на страницу
        location.href = 'commerce-apartment.php?id=' + commercialPremises[$(this).index()].id;
    });

}})(jQuery, window.yesidea || (window.yesidea = {}));